'use strict';

import 'google';


export default function() {
	'ngInject';

	return {
		scope: {
			zoom: '<',
			lat: '<',
			lng: '<',
			points: '<',
		},
		link: link,
	}

	function link(scope, element, attrs, ctrls) {
		var map = new google.maps.Map(element[0], {
			zoom: scope.zoom,
			center: {lat: scope.lat, lng: scope.lng},
			mapTypeId: 'satellite'
		});

		var googlePoints = [];
		scope.points.forEach(function(p) {
			googlePoints.push(new google.maps.LatLng(p[0], p[1]));
		});

		var heatmap = new google.maps.visualization.HeatmapLayer({
			data: googlePoints,
			map: map,
			radius: 20,
			maxIntensity: 25,
		});

	}
}
